// Central brand config + copy content for BullsEdge Academy (premium dark theme)

export const BRAND = {
  name: "BullsEdge Academy",
  center: "Ahmedabad Center",
  logo: "https://customer-assets-m6fa6gv7.emergentagent.net/job_f3d6c2a0-c202-4ed8-8ec5-510a4edd5a0f/artifacts/hz5gmq02_favicon.webp",
  phone: "+918799118849",
  phoneDisplay: "+91 87991 18849",
  whatsapp:
    "https://wa.me/918799118849?text=" +
    encodeURIComponent(
      "Hi BullsEdge Academy! I'd like to know more about your Ahmedabad trading batches (offline / online support)."
    ),
  maps:
    "https://www.google.com/maps/search/?api=1&query=BullsEdge+Academy+A-504+Dev+Aurum+Commercial+Building+Anand+Nagar+Crossroad+Prahladanagar+Ahmedabad+380015",
  addressLines: [
    "A-504, Dev Aurum Commercial Building,",
    "Anand Nagar Crossroad, Prahladanagar,",
    "Ahmedabad – 380015, Gujarat",
  ],
};

export const IMAGES = {
  heroClassroom: "/classroom/hero.jpg",
  tradingDesk:
    "https://images.pexels.com/photos/5831260/pexels-photo-5831260.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  building:
    "https://images.unsplash.com/photo-1645497781181-d6684ebd1863?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBvZmZpY2UlMjBidWlsZGluZyUyMGV4dGVyaW9yJTIwbmlnaHR8ZW58MHx8fHwxNzg0ODkxNzYxfDA&ixlib=rb-4.1.0&q=85",
  classroom1: "/classroom/classroom1.jpg",
  classroom2: "/classroom/classroom2.jpg",
  reel: "https://customer-assets-39nsmqrw.emergentagent.net/job_classroom-trader/artifacts/bgvnaqrp_Class%20Landing%20Page%20Edit_instagram_reels.mp4",
};

export const STATS = [
  { icon: "award", value: "10+", label: "Years of Experience" },
  { icon: "users", value: "1000+", label: "Students Trained" },
  { icon: "presentation", value: "50+", label: "Live Workshops Conducted" },
  { icon: "star", value: "200+", label: "Five-Star Reviews" },
];

export const DIFFERENTIATORS = [
  {
    icon: "live",
    title: "Live Trading with Mentors",
    body: "Watch trades happen live, explained in real time, not from a recording.",
  },
  {
    icon: "community",
    title: "Traders Community",
    body: "Join a network of traders who discuss ideas and trade alongside each other.",
  },
  {
    icon: "floor",
    title: "Live Trading Floor",
    body: "Practical sessions right on our trading floor, during live market hours.",
  },
  {
    icon: "online",
    title: "Online Support Too",
    body: "Can't attend in person every day? Get every class recording plus online support, so you never fall behind.",
  },
];

export const PROBLEMS = [
  {
    title: "Learning Alone",
    body: "Watching videos at home, but nobody's there to catch your mistakes.",
  },
  {
    title: "Fake Tips",
    body: 'Following random Telegram groups and "gurus" — and watching your money shrink.',
  },
  {
    title: "Trading on Emotion",
    body: "Making decisions out of fear or greed because there's no one to keep you disciplined.",
  },
  {
    title: "No One Checking Your Work",
    body: "No mentor looking at your charts and telling you what's wrong.",
  },
  {
    title: "No Real Community",
    body: "Learning in isolation instead of around other serious traders.",
  },
];

export const CURRICULUM = [
  {
    icon: "chart",
    title: "Reading the Market Live",
    body: "Learn to read charts and price movement — live, as it happens, not from a recording.",
  },
  {
    icon: "shield",
    title: "Protecting Your Capital",
    body: "How much to invest, when to exit, and how to avoid big losses.",
  },
  {
    icon: "brain",
    title: "Trading Mindset",
    body: "How to stay calm and disciplined instead of trading on fear or greed.",
  },
  {
    icon: "discipline",
    title: "Building Discipline",
    body: "How to build your own trading routine and stick to it.",
  },
  {
    icon: "practical",
    title: "Practical Sessions in Live Market",
    body: "Real classroom time spent watching and reacting to the live market, not just theory.",
  },
  {
    icon: "strategy",
    title: "High Win-Rate Strategies",
    body: "Learn strategies that have been tested and refined over years of live market data.",
  },
];

export const MARKETS = [
  "Equity (NSE / BSE)",
  "Futures & Options (F&O)",
  "Commodities (Gold, Silver, Crude Oil)",
  "Forex",
  "Crypto",
];

export const TESTIMONIALS = [
  {
    quote:
      "Watching live trades get explained right in front of me, step by step — that's what changed things for me.",
    name: "Laxmi Y.",
  },
  {
    quote:
      "I knew nothing about the stock market before this. Learning in person at the Ahmedabad center gave me real confidence.",
    name: "Mandeep S.",
  },
  {
    quote:
      "The classroom sessions on mindset hit different. You just can't get that from a video.",
    name: "Sujal B.",
  },
  {
    quote:
      "Having a mentor check my risk decisions in person saved me from some big mistakes.",
    name: "Manoj K.",
  },
];

// Multi-step inquiry modal
export const ELIGIBILITY_STEPS = [
  {
    key: "experience",
    question: "What's your current trading experience?",
    caption: "This helps our mentors place you in the right batch.",
    options: ["Complete Beginner", "Some Experience", "Active Trader"],
  },
  {
    key: "focus",
    question: "Which markets are you most interested in?",
    caption: "We cover the full spectrum in class.",
    options: ["Equity", "Options (F&O)", "Commodities", "Forex", "Crypto"],
  },
  {
    key: "timeline",
    question: "What class timing works best for you?",
    caption: "We run multiple offline & online-support batches.",
    options: ["Weekday Mornings", "Weekday Evenings", "Weekends", "Flexible / Online"],
  },
  {
    key: "capital",
    question: "What is your trading capital?",
    caption: "This helps your mentor plan position sizing and risk for you.",
    options: ["₹10,000 – ₹50,000", "₹50,000 – ₹1 Lakh", "₹1 Lakh – ₹2 Lakh", "₹2 Lakh+"],
  },
];

// ---------- Online batch landing page (/online) ----------
export const ONLINE_WHATSAPP =
  "https://wa.me/918799118849?text=" +
  encodeURIComponent(
    "Hi BullsEdge Academy! I'm [losing in trades / new to the market] and want to build a trading plan. Please share details of the 90-day online batch and the 2-session free trial."
  );

export const ONLINE_DIFFERENTIATORS = [
  {
    icon: "live",
    title: "Live Trading With Mentors",
    body: "Watch real trades explained in real time, then place your own with your mentor reviewing.",
  },
  {
    icon: "plan",
    title: "A Plan, Not Just Videos",
    body: "A week-by-week structure ending in a written trading plan that is yours.",
  },
  {
    icon: "notips",
    title: "Zero Tips, Zero Guesswork",
    body: "We never send signals. Every trade you take follows your own plan and fixed risk.",
  },
  {
    icon: "online",
    title: "Never Fall Behind",
    body: "Every session is recorded, and doubt support is included.",
  },
];

export const ONLINE_SESSION_POINTS = [
  "Mentor-led live chart breakdowns",
  "Small batches, so every trade gets reviewed",
  "Screen-shared drills and risk checks",
];

export const ONLINE_ROADMAP = [
  {
    days: "Days 1–30",
    title: "Foundation",
    body: "Read charts and price movement, and understand market basics. Beginners build the base, and losing traders fix the gaps.",
  },
  {
    days: "Days 31–60",
    title: "Risk & Mindset",
    body: "Fix your risk per trade, plan every exit and stay disciplined under pressure. You finish with your written trading plan.",
  },
  {
    days: "Days 61–90",
    title: "Live Execution",
    body: "Place 10 planned live trades from your own plan, each one reviewed by your mentor.",
  },
];

export const ONLINE_JOIN_POINTS = [
  "Join easily from your phone or laptop",
  "Live market screens shared in class",
  "Doubt-solving with your mentor",
];

export const ONLINE_PROBLEMS = [
  {
    title: "Learning Alone",
    body: "Watching videos at home, but nobody catches your mistakes.",
  },
  {
    title: "Fake Tips",
    body: "Following random Telegram “gurus” while your money shrinks.",
  },
  {
    title: "Trading on Emotion",
    body: "Deciding out of fear or greed because there's no plan.",
  },
  {
    title: "No One Checking Your Work",
    body: "No mentor looks at your trades and tells you what's wrong.",
  },
  {
    title: "No Real Community",
    body: "Learning in isolation instead of alongside serious traders.",
  },
];

export const ONLINE_LEARN = [
  {
    icon: "chart",
    title: "Reading the Market Live",
    body: "Read charts and price movement as it happens, not from a recording.",
  },
  {
    icon: "shield",
    title: "Fixed Risk on Every Trade",
    body: "How much to risk, when to exit and how to avoid big losses — 1–2% of capital per trade.",
  },
  {
    icon: "brain",
    title: "Trading Mindset",
    body: "Stay calm and disciplined instead of trading on fear or greed.",
  },
  {
    icon: "plan",
    title: "Your Own Written Trading Plan",
    body: "A plan you built yourself and can follow after the course.",
  },
  {
    icon: "trades",
    title: "10 Planned Live Trades",
    body: "Real trades in the live market, each with an entry, exit and risk set before you place it.",
  },
  {
    icon: "review",
    title: "Mentor Review",
    body: "Every planned trade is reviewed, so you know what worked and what didn't.",
  },
];

export const ONLINE_MARQUEE = [
  "We Build Traders",
  "Not Tips",
  "Written Plan",
  "10 Planned Trades",
  "90 Days",
  "Risk-Free Start",
];
